/* eslint-disable */
import { Header } from './components/header';
import { default as ATElement } from '../assets/headers/AT.svg?react';
import { default as AbsenceElement } from '../assets/headers/Absence.svg?react';
import { default as ActionBlueElement } from '../assets/headers/ActionBlue.svg?react';
import { default as ActionNavyElement } from '../assets/headers/ActionNavy.svg?react';
import { default as ActionYellowElement } from '../assets/headers/ActionYellow.svg?react';
import { default as ActionsElement } from '../assets/headers/Actions.svg?react';
import { default as AjoutATElement } from '../assets/headers/AjoutAT.svg?react';
import { default as AjoutEpiElement } from '../assets/headers/AjoutEpi.svg?react';
import { default as AjoutPersonnesElement } from '../assets/headers/AjoutPersonnes.svg?react';
import { default as AjoutTalentElement } from '../assets/headers/AjoutTalent.svg?react';
import { default as AssistanceElement } from '../assets/headers/Assistance.svg?react';
import { default as AttentionElement } from '../assets/headers/Attention.svg?react';
import { default as CVElement } from '../assets/headers/CV.svg?react';
import { default as CacesElement } from '../assets/headers/Caces.svg?react';
import { default as CalendrierElement } from '../assets/headers/Calendrier.svg?react';
import { default as ChallengerElement } from '../assets/headers/Challenger.svg?react';
import { default as CommandeElement } from '../assets/headers/Commande.svg?react';
import { default as CommunicationElement } from '../assets/headers/Communication.svg?react';
import { default as CompetencesElement } from '../assets/headers/Competences.svg?react';
import { default as CompteRenduElement } from '../assets/headers/CompteRendu.svg?react';
import { default as ComptesElement } from '../assets/headers/Comptes.svg?react';
import { default as ConclusionElement } from '../assets/headers/Conclusion.svg?react';
import { default as ContactElement } from '../assets/headers/Contact.svg?react';
import { default as ContratElement } from '../assets/headers/Contrat.svg?react';
import { default as DeleteAlerteElement } from '../assets/headers/DeleteAlerte.svg?react';
import { default as DerogationElement } from '../assets/headers/Derogation.svg?react';
import { default as DetailsElement } from '../assets/headers/Details.svg?react';
import { default as DialogueElement } from '../assets/headers/Dialogue.svg?react';
import { default as DiplomesElement } from '../assets/headers/Diplomes.svg?react';
import { default as DisponibilitesElement } from '../assets/headers/Disponibilites.svg?react';
import { default as DocElement } from '../assets/headers/Doc.svg?react';
import { default as EchangeElement } from '../assets/headers/Echange.svg?react';
import { default as EmailElement } from '../assets/headers/Email.svg?react';
import { default as ExperienceElement } from '../assets/headers/Experience.svg?react';
import { default as ExportBlueElement } from '../assets/headers/ExportBlue.svg?react';
import { default as ExportGreenishElement } from '../assets/headers/ExportGreenish.svg?react';
import { default as ExportNavyElement } from '../assets/headers/ExportNavy.svg?react';
import { default as FavorisElement } from '../assets/headers/Favoris.svg?react';
import { default as FelicitationsBallonsElement } from '../assets/headers/FelicitationsBallons.svg?react';
import { default as FelicitationsFeuDartificeElement } from '../assets/headers/FelicitationsFeuDartifice.svg?react';
import { default as FelicitationsTchinElement } from '../assets/headers/FelicitationsTchin.svg?react';
import { default as FiltresElement } from '../assets/headers/Filtres.svg?react';
import { default as FinActionJauneElement } from '../assets/headers/FinActionJaune.svg?react';
import { default as FinActionRougeElement } from '../assets/headers/FinActionRouge.svg?react';
import { default as HabilitationsBlueElement } from '../assets/headers/HabilitationsBlue.svg?react';
import { default as HabilitationsJauneElement } from '../assets/headers/HabilitationsJaune.svg?react';
import { default as HumainElement } from '../assets/headers/Humain.svg?react';
import { default as HumainAgenceElement } from '../assets/headers/HumainAgence.svg?react';
import { default as ImpactElement } from '../assets/headers/Impact.svg?react';
import { default as InterversionElement } from '../assets/headers/Interversion.svg?react';
import { default as LanguesElement } from '../assets/headers/Langues.svg?react';
import { default as ListeElement } from '../assets/headers/Liste.svg?react';
import { default as MemoElement } from '../assets/headers/Memo.svg?react';
import { default as MetierElement } from '../assets/headers/Metier.svg?react';
import { default as MissionsElement } from '../assets/headers/Missions.svg?react';
import { default as ModifiyElement } from '../assets/headers/Modifiy.svg?react';
import { default as MotsClefsElement } from '../assets/headers/MotsClefs.svg?react';
import { default as NotificationElement } from '../assets/headers/Notification.svg?react';
import { default as NouveauElement } from '../assets/headers/Nouveau.svg?react';
import { default as NouveauteElement } from '../assets/headers/Nouveaute.svg?react';
import { default as OrgnisationElement } from '../assets/headers/Orgnisation.svg?react';
import { default as OrgnisationAgenceElement } from '../assets/headers/OrgnisationAgence.svg?react';
import { default as ParametresElement } from '../assets/headers/Parametres.svg?react';
import { default as PeopleElement } from '../assets/headers/People.svg?react';
import { default as PermisElement } from '../assets/headers/Permis.svg?react';
import { default as PoolElement } from '../assets/headers/Pool.svg?react';
import { default as PotentielsElement } from '../assets/headers/Potentiels.svg?react';
import { default as PoursuivreElement } from '../assets/headers/Poursuivre.svg?react';
import { default as PresenceElement } from '../assets/headers/Presence.svg?react';
import { default as PrimesElement } from '../assets/headers/Primes.svg?react';
import { default as ProfilIconeElement } from '../assets/headers/ProfilIcone.svg?react';
import { default as ProfilVisuElement } from '../assets/headers/ProfilVisu.svg?react';
import { default as QualificationsElement } from '../assets/headers/Qualifications.svg?react';
import { default as RecapitulationBlueElement } from '../assets/headers/RecapitulationBlue.svg?react';
import { default as RecapitulationJauneElement } from '../assets/headers/RecapitulationJaune.svg?react';
import { default as RefusElement } from '../assets/headers/Refus.svg?react';
import { default as RenameElement } from '../assets/headers/Rename.svg?react';
import { default as ReportingElement } from '../assets/headers/Reporting.svg?react';
import { default as RisqueRoutierElement } from '../assets/headers/RisqueRoutier.svg?react';
import { default as SMSElement } from '../assets/headers/SMS.svg?react';
import { default as SecuriteElement } from '../assets/headers/Securite.svg?react';
import { default as SensibilisationElement } from '../assets/headers/Sensibilisation.svg?react';
import { default as ServicesElement } from '../assets/headers/Services.svg?react';
import { default as SignatureElement } from '../assets/headers/Signature.svg?react';
import { default as SortiePoolElement } from '../assets/headers/SortiePool.svg?react';
import { default as StartElement } from '../assets/headers/Start.svg?react';
import { default as StepElement } from '../assets/headers/Step.svg?react';
import { default as SuccessElement } from '../assets/headers/Success.svg?react';
import { default as TechniqueElement } from '../assets/headers/Technique.svg?react';
import { default as TechniqueAgenceElement } from '../assets/headers/TechniqueAgence.svg?react';
import { default as TelephoneElement } from '../assets/headers/Telephone.svg?react';
import { default as TransfertElement } from '../assets/headers/Transfert.svg?react';
import { default as UnitesGreenishElement } from '../assets/headers/UnitesGreenish.svg?react';
import { default as UnitesJauneElement } from '../assets/headers/UnitesJaune.svg?react';
import { default as ValidationElement } from '../assets/headers/Validation.svg?react';
import { default as VariableElement } from '../assets/headers/Variable.svg?react';
import { default as VillesElement } from '../assets/headers/Villes.svg?react';

export const AT = Header(ATElement);
export const Absence = Header(AbsenceElement);
export const ActionBlue = Header(ActionBlueElement);
export const ActionNavy = Header(ActionNavyElement);
export const ActionYellow = Header(ActionYellowElement);
export const Actions = Header(ActionsElement);
export const AjoutAT = Header(AjoutATElement);
export const AjoutEpi = Header(AjoutEpiElement);
export const AjoutPersonnes = Header(AjoutPersonnesElement);
export const AjoutTalent = Header(AjoutTalentElement);
export const Assistance = Header(AssistanceElement);
export const Attention = Header(AttentionElement);
export const CV = Header(CVElement);
export const Caces = Header(CacesElement);
export const Calendrier = Header(CalendrierElement);
export const Challenger = Header(ChallengerElement);
export const Commande = Header(CommandeElement);
export const Communication = Header(CommunicationElement);
export const Competences = Header(CompetencesElement);
export const CompteRendu = Header(CompteRenduElement);
export const Comptes = Header(ComptesElement);
export const Conclusion = Header(ConclusionElement);
export const Contact = Header(ContactElement);
export const Contrat = Header(ContratElement);
export const DeleteAlerte = Header(DeleteAlerteElement);
export const Derogation = Header(DerogationElement);
export const Details = Header(DetailsElement);
export const Dialogue = Header(DialogueElement);
export const Diplomes = Header(DiplomesElement);
export const Disponibilites = Header(DisponibilitesElement);
export const Doc = Header(DocElement);
export const Echange = Header(EchangeElement);
export const Email = Header(EmailElement);
export const Experience = Header(ExperienceElement);
export const ExportBlue = Header(ExportBlueElement);
export const ExportGreenish = Header(ExportGreenishElement);
export const ExportNavy = Header(ExportNavyElement);
export const Favoris = Header(FavorisElement);
export const FelicitationsBallons = Header(FelicitationsBallonsElement);
export const FelicitationsFeuDartifice = Header(FelicitationsFeuDartificeElement);
export const FelicitationsTchin = Header(FelicitationsTchinElement);
export const Filtres = Header(FiltresElement);
export const FinActionJaune = Header(FinActionJauneElement);
export const FinActionRouge = Header(FinActionRougeElement);
export const HabilitationsBlue = Header(HabilitationsBlueElement);
export const HabilitationsJaune = Header(HabilitationsJauneElement);
export const Humain = Header(HumainElement);
export const HumainAgence = Header(HumainAgenceElement);
export const Impact = Header(ImpactElement);
export const Interversion = Header(InterversionElement);
export const Langues = Header(LanguesElement);
export const Liste = Header(ListeElement);
export const Memo = Header(MemoElement);
export const Metier = Header(MetierElement);
export const Missions = Header(MissionsElement);
export const Modifiy = Header(ModifiyElement);
export const MotsClefs = Header(MotsClefsElement);
export const Notification = Header(NotificationElement);
export const Nouveau = Header(NouveauElement);
export const Nouveaute = Header(NouveauteElement);
export const Orgnisation = Header(OrgnisationElement);
export const OrgnisationAgence = Header(OrgnisationAgenceElement);
export const Parametres = Header(ParametresElement);
export const People = Header(PeopleElement);
export const Permis = Header(PermisElement);
export const Pool = Header(PoolElement);
export const Potentiels = Header(PotentielsElement);
export const Poursuivre = Header(PoursuivreElement);
export const Presence = Header(PresenceElement);
export const Primes = Header(PrimesElement);
export const ProfilIcone = Header(ProfilIconeElement);
export const ProfilVisu = Header(ProfilVisuElement);
export const Qualifications = Header(QualificationsElement);
export const RecapitulationBlue = Header(RecapitulationBlueElement);
export const RecapitulationJaune = Header(RecapitulationJauneElement);
export const Refus = Header(RefusElement);
export const Rename = Header(RenameElement);
export const Reporting = Header(ReportingElement);
export const RisqueRoutier = Header(RisqueRoutierElement);
export const SMS = Header(SMSElement);
export const Securite = Header(SecuriteElement);
export const Sensibilisation = Header(SensibilisationElement);
export const Services = Header(ServicesElement);
export const Signature = Header(SignatureElement);
export const SortiePool = Header(SortiePoolElement);
export const Start = Header(StartElement);
export const Step = Header(StepElement);
export const Success = Header(SuccessElement);
export const Technique = Header(TechniqueElement);
export const TechniqueAgence = Header(TechniqueAgenceElement);
export const Telephone = Header(TelephoneElement);
export const Transfert = Header(TransfertElement);
export const UnitesGreenish = Header(UnitesGreenishElement);
export const UnitesJaune = Header(UnitesJauneElement);
export const Validation = Header(ValidationElement);
export const Variable = Header(VariableElement);
export const Villes = Header(VillesElement);
